<template>
  <!-- 英文 -->
  <div
    class="inherit"
    v-if="this.language == 'eng'"
    style="font-family: 'Times New Roman', Times, serif"
  >
    <Pic-top></Pic-top>
    <div class="exhibitionTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">Home</span>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">Inheritor</span>
        </div>
        <div class="search_input">
          <el-input
            ref="searchInput"
            @focus="handleFocus"
            @blur="handleBlur"
            v-model="queryInfo.chineseName"
            placeholder="Please enter the inheritor"
          ></el-input>
          <div class="searchButton" @click="handSearchOther()">
            <img src="../../assets/newImageBgc/search.png" alt />
          </div>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="inheritContent">
      <div class="people">
        <div
          class="person englishPerson"
          v-for="(item, index) in List"
          :key="index"
          :class="isActive == item.id ? 'isActive' : ''"
          @click="goPainting(item.id, index)"
        >
          {{ item.eng_title }}
        </div>
      </div>
      <div class="level">
        <div
          class="person englishPerson"
          v-for="(item, index) in levels"
          :key="index"
          :class="isActives == item.id ? 'isActive' : ''"
          @click="goPaintings(item.id, index)"
        >
          {{ item.eng_level }}
        </div>
      </div>
      <div class="section" v-if="list.length > 0">
        <div
          class="item wow animate__animated animate__fadeInDown"
          v-for="(item, index) in list"
          :key="index"
          @click="goDetail(item)"
        >
          <div class="left">
            <img :src="url + item.picture[0].fileUrl" alt="" />
          </div>
          <div class="right">
            <div class="title eng_title">
              {{ item.englishName }}
            </div>
            <div class="master englishMaster">
              <div
                class="inheritorNameList"
                v-if="
                  item.inheritorLevelIdArrStr &&
                  item.inheritorLevelIdArrStr.length > 0
                "
              >
                <div
                  class="inheritorNameItem"
                  v-for="(items, index) in item.inheritorLevelIdArrStr"
                  :key="index"
                >
                  <div v-if="items && items == 1">
                    Representative inheritor of Regong art, a national
                    intangible cultural heritage project
                  </div>
                  <div v-if="items && items == 2">
                    Representative inheritor of Regong art, an intangible
                    cultural heritage project in Qinghai Province
                  </div>
                  <div v-if="items && items == 3">
                    Representative inheritor of Regong art, an intangible
                    cultural heritage project in Huangnan Prefecture, Qinghai
                    Province
                  </div>
                  <div v-if="items && items == 4">
                    Representative inheritor of Regong art, an intangible
                    cultural heritage project in Tongren City, Huangnan
                    Prefecture, Qinghai Province
                  </div>
                </div>
              </div>
              <div
                class="artistsLevelNameList"
                v-if="
                  item.artistsLevelIdArrStr &&
                  item.artistsLevelIdArrStr.length > 0
                "
              >
                <div
                  class="artistsLevelNameItem"
                  v-for="(items, index) in item.artistsLevelIdArrStr"
                  :key="index"
                >
                  <div v-if="items && items == 1">
                    Chinese Arts and Crafts Masters
                  </div>
                  <div v-if="items && items == 2">
                    Master of Arts and Crafts in Qinghai Province
                  </div>
                  <div v-if="items && items == 3">
                    Master of Arts and Crafts in Huangnan Prefecture, Qinghai
                    Province
                  </div>
                  <div v-if="items && items == 4">
                    Master of Arts and Crafts in Tongren City, Huangnan
                    Prefecture, Qinghai Province
                  </div>
                </div>
              </div>
              <div class="folkLevelNameList" v-if="item.technologistLevel">
                <div v-if="item && item.technologistLevel == 1">
                  Qinghai Province Folk Crafts Master
                </div>
                <div v-if="item && item.technologistLevel == 2">
                  Qinghai Provincial First Class Folk Craftsman
                </div>
                <div v-if="item && item.technologistLevel == 3">
                  Qinghai Provincial Second Class Folk Craftsman
                </div>
                <div v-if="item && item.technologistLevel == 4">
                  Qinghai Provincial Third Class Folk Craftsman
                </div>
                <div v-if="item && item.technologistLevel == 5">
                  Folk Craftsman of Huangnan Prefecture, Qinghai Province
                </div>
                <div v-if="item && item.technologistLevel == 6">
                  Folk Craftsman in Tongren City, Huangnan Prefecture, Qinghai
                  Province
                </div>
              </div>
            </div>
            <div class="content" @click="goDetail(item)">
              {{ item.englishDesc }}
            </div>
          </div>
        </div>
      </div>
      <div class="section noneContent" v-if="list.length == 0 && !loading">
        none
      </div>
      <div
        class="loading"
        v-loading="loading"
        element-loading-text="loading"
        element-loading-spinner="el-icon-loading"
      ></div>
    </div>
  </div>
  <!-- 藏文 -->
  <div class="inherit" v-else-if="this.language == 'en'">
    <Pic-top></Pic-top>
    <div class="exhibitionTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)"> ངོ་བྱང་།</span>
          <span>&nbsp;>&nbsp;</span>
          <span class="color"> རྒྱུན་འཛིན་པ།</span>
        </div>
        <div class="search_input">
          <el-input
            ref="searchInput"
            @focus="handleFocus"
            @blur="handleBlur"
            v-model="queryInfo.chineseName"
            placeholder="རྒྱུན་འཛིན་པ།"
          ></el-input>
          <div class="searchButton" @click="handSearchOther()">
            <img src="../../assets/newImageBgc/search.png" alt />
          </div>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="inheritContent">
      <div class="people">
        <div
          class="person englishPerson"
          v-for="(item, index) in List"
          :key="index"
          :class="isActive == item.id ? 'isActive' : ''"
          @click="goPainting(item.id, index)"
        >
          {{ item.za_title }}
        </div>
      </div>
      <div class="level">
        <div
          class="person englishPerson"
          v-for="(item, index) in levels"
          :key="index"
          :class="isActives == item.id ? 'isActive' : ''"
          @click="goPaintings(item.id, index)"
        >
          {{ item.za_level }}
        </div>
      </div>
      <div class="section" v-if="list.length > 0">
        <div
          class="item wow animate__animated animate__fadeInDown"
          v-for="(item, index) in list"
          :key="index"
          @click="goDetail(item)"
        >
          <div class="left">
            <img :src="url + item.picture[0].fileUrl" alt="" />
          </div>
          <div class="right">
            <div class="title">{{ item.zangName }}</div>
            <div class="master">
              <div
                class="inheritorNameList"
                v-if="
                  item.inheritorLevelIdArrStr &&
                  item.inheritorLevelIdArrStr.length > 0
                "
              >
                <div
                  class="inheritorNameItem"
                  v-for="(items, index) in item.inheritorLevelIdArrStr"
                  :key="index"
                >
                  <div v-if="items && items == 1">
                    རྒྱལ་ཁབ་རིམ་པའི་གཟུགས་མེད་རིག་གནས་ལས་གཞི་རེབ་གོང་སྒྱུ་རྩལ་གྱི་འཐུས་ཚབ་རང་བཞིན་གྱི་རྒྱུན་འཛིན་པ།
                  </div>
                  <div v-if="items && items == 2">
                    མཚོ་སྔོན་ཞིང་ཆེན་གཟུགས་མེད་རིག་གནས་ལས་གཞི་རེབ་གོང་སྒྱུ་རྩལ་གྱི་འཐུས་ཚབ་རང་བཞིན་གྱི་རྒྱུན་འཛིན་པ།
                  </div>
                  <div v-if="items && items == 3">
                    མཚོ་སྔོན་ཞིང་ཆེན་རྨ་ལྷོ་ཁུལ་གཟུགས་མེད་རིག་གནས་ལས་གཞི་རེབ་གོང་སྒྱུ་རྩལ་གྱི་འཐུས་ཚབ་རང་བཞིན་གྱི་རྒྱུན་འཛིན་པ།
                  </div>
                  <div v-if="items && items == 4">
                    མཚོ་སྔོན་ཞིང་ཆེན་རྨ་ལྷོ་ཁུལ་ཐུན་རིན་གྲོང་ཁྱེར་གཟུགས་མེད་རིག་གནས་ལས་གཞི་རེབ་གོང་སྒྱུ་རྩལ་གྱི་འཐུས་ཚབ་རང་བཞིན་གྱི་རྒྱུན་འཛིན་པ།
                  </div>
                </div>
              </div>
              <div
                class="artistsLevelNameList"
                v-if="
                  item.artistsLevelIdArrStr &&
                  item.artistsLevelIdArrStr.length > 0
                "
              >
                <div
                  class="artistsLevelNameItem"
                  v-for="(items, index) in item.artistsLevelIdArrStr"
                  :key="index"
                >
                  <div v-if="items && items == 1">
                    ཀྲུང་གོའི་བཟོ་རྩལ་མཛེས་རྩལ་མཁས་པ་
                  </div>
                  <div v-if="items && items == 2">
                    མཚོ་སྔོན་ཞིང་ཆེན་གྱི་བཟོ་རྩལ་མཛེས་རྩལ་མཁས་པ་ཆེན་མོ་
                  </div>
                  <div v-if="items && items == 3">
                    མཚོ་སྔོན་ཞིང་ཆེན་རྨ་ལྷོ་ཀྲོའུ་བཟོ་རྩལ་མཛེས་རྩལ་ཆེ་མོ་བ།
                  </div>
                  <div v-if="items && items == 4">
                    མཚོ་སྔོན་རྨ་ལྷོ་ཀྲོའུ་རེབ་གོང་གྲོང་ཁྱེར་གྱི་བཟོ་རྩལ་མཛེས་རྩལ་ཆེ་མོ་བ།
                  </div>
                </div>
              </div>
              <div class="folkLevelNameList" v-if="item.technologistLevel">
                <div v-if="item && item.technologistLevel == 1">
                  མཚོ་སྔོན་ཞིང་ཆེན་གྱི་དམངས་ཁྲོད་བཟོ་རྩལ་མཁས་པ་
                </div>
                <div v-if="item && item.technologistLevel == 2">
                  མཚོ་སྔོན་ཞིང་ཆེན་དམངས་ཁྲོད་བཟོ་རྩལ་པ་རིམ་པ་དང་པོ་
                </div>
                <div v-if="item && item.technologistLevel == 3">
                  མཚོ་སྔོན་ཞིང་ཆེན་གྱི་དམངས་ཁྲོད་བཟོ་རྩལ་པ་རིམ་པ་གཉིས་པ་
                </div>
                <div v-if="item && item.technologistLevel == 4">
                  མཚོ་སྔོན་ཞིང་ཆེན་གྱི་དམངས་ཁྲོད་བཟོ་རྩལ་པ་རིམ་པ་གསུམ་པ་
                </div>
                <div v-if="item && item.technologistLevel == 5">
                  མཚོ་སྔོན་ཞིང་ཆེན་རྨ་ལྷོ་ཀྲོའུ་དམངས་ཁྲོད་བཟོ་རྩལ་པ་
                </div>
                <div v-if="item && item.technologistLevel == 6">
                  མཚོ་སྔོན་རྨ་ལྷོ་ཀྲོའུ་རེབ་གོང་གྲོང་མིའི་བཟོ་རྩལ་པ་
                </div>
              </div>
            </div>
            <div class="content" @click="goDetail(item)">
              {{ item.zangDesc }}
            </div>
          </div>
        </div>
      </div>
      <div class="section noneContent" v-if="list.length == 0 && !loading">
        གནས་སྐབས་གཞི་གྲངས་མེད་པ་
      </div>
      <div
        class="loading"
        v-loading="loading"
        element-loading-text="གཞི་གྲངས་སྣོན་འཇུག་ཁྲོད་"
        element-loading-spinner="el-icon-loading"
      ></div>
    </div>
  </div>
  <!-- 中文 -->
  <div class="inherit" v-else>
    <Pic-top></Pic-top>
    <div class="exhibitionTop">
      <div class="section">
        <div class="section_left">
          <span @click="handleRouter(1)">首页</span>
          <span>&nbsp;>&nbsp;</span>
          <span class="color">传承人</span>
        </div>
        <div class="search_input">
          <el-input
            v-model="queryInfo.chineseName"
            placeholder="请输入传承人名称"
            ref="searchInput"
            @focus="handleFocus"
            @blur="handleBlur"
          ></el-input>
          <div class="searchButton" @click="handSearchOther()">
            <img src="../../assets/newImageBgc/search.png" alt />
          </div>
        </div>
      </div>
      <img
        class="cloudLeft hidden-xs-only wow animate__animated animate__fadeInLeft"
        src="../../assets/newImage/index/could_left.png"
        alt=""
      />
    </div>
    <div class="inheritContent">
      <div class="people">
        <div
          class="person"
          v-for="(item, index) in List"
          :key="index"
          :class="isActive == item.id ? 'isActive' : ''"
          @click="goPainting(item.id, index)"
        >
          {{ item.title }}
        </div>
      </div>
      <div class="level">
        <div
          class="person"
          v-for="(item, index) in levels"
          :key="index"
          :class="isActives == item.id ? 'isActive' : ''"
          @click="goPaintings(item.id, index)"
        >
          {{ item.level }}
        </div>
      </div>
      <div class="section" v-if="list.length > 0">
        <div
          class="item wow animate__animated"
          v-for="(item, index) in list"
          :key="index"
          @click="goDetail(item)"
        >
          <div class="left">
            <img :src="url + item.picture[0].fileUrl" alt="" />
          </div>
          <div class="right">
            <div class="title">
              {{ item.chineseName }}
            </div>
            <div class="master">
              <div
                class="inheritorNameList"
                v-if="
                  item.inheritorLevelIdArrStr &&
                  item.inheritorLevelIdArrStr.length > 0
                "
              >
                <div
                  class="inheritorNameItem"
                  v-for="(items, index) in item.inheritorLevelIdArrStr"
                  :key="index"
                >
                  <div v-if="items && items == 1">
                    国家级非遗项目热贡艺术代表性传承人
                  </div>
                  <div v-if="items && items == 2">
                    青海省非遗项目热贡艺术代表性传承人
                  </div>
                  <div v-if="items && items == 3">
                    青海省黄南州非遗项目热贡艺术代表性传承人
                  </div>
                  <div v-if="items && items == 4">
                    青海省黄南州同仁市非遗项目热贡艺术代表性传承人
                  </div>
                </div>
              </div>
              <div
                class="artistsLevelNameList"
                v-if="
                  item.artistsLevelIdArrStr &&
                  item.artistsLevelIdArrStr.length > 0
                "
              >
                <div
                  class="artistsLevelNameItem"
                  v-for="(items, index) in item.artistsLevelIdArrStr"
                  :key="index"
                >
                  <div v-if="items && items == 1">中国工艺美术大师</div>
                  <div v-if="items && items == 2">青海省工艺美术大师</div>
                  <div v-if="items && items == 3">青海省黄南州工艺美术大师</div>
                  <div v-if="items && items == 4">
                    青海省黄南州同仁市工艺美术大师
                  </div>
                </div>
              </div>
              <div class="folkLevelNameList" v-if="item.technologistLevel">
                <div v-if="item && item.technologistLevel == 1">
                  青海省民间工艺大师
                </div>
                <div v-if="item && item.technologistLevel == 2">
                  青海省一级民间工艺师
                </div>
                <div v-if="item && item.technologistLevel == 3">
                  青海省二级民间工艺师
                </div>
                <div v-if="item && item.technologistLevel == 4">
                  青海省三级民间工艺师
                </div>
                <div v-if="item && item.technologistLevel == 5">
                  青海省黄南州民间工艺师
                </div>
                <div v-if="item && item.technologistLevel == 6">
                  青海省黄南州同仁市民间工艺师
                </div>
              </div>
            </div>
            <div class="content" @click="goDetail(item)">
              {{ item.chineseDesc }}
            </div>
          </div>
        </div>
      </div>
      <div class="section noneContent" v-if="list.length == 0 && !loading">
        暂无数据
      </div>
      <div
        class="loading"
        v-loading="loading"
        element-loading-text="数据加载中"
        element-loading-spinner="el-icon-loading"
      ></div>
    </div>
  </div>
</template>
<script>
import PicTop from "../../components/picsTop.vue";
import { noticePage, inherit } from "../../api/management";
import { throttle } from "lodash";
export default {
  components: {
    PicTop,
  },
  data() {
    return {
      isActive: 0,
      isActives: 0,
      List: [
        {
          title: "全部",
          eng_title: "All",
          za_title: "ཚང་མ་ནི།",
          id: 0,
        },
        {
          title: "工艺美术师",
          eng_title: "Craft Artists",
          za_title: "བཟོ་རྩལ་མཛེས་རྩལ་མཁས་པ།",
          id: 1,
        },
        {
          title: "非遗传承人",
          eng_title: "Inheritor of Intangible Cultural Heritage",
          za_title: "མངོན་མིན་རིག་གནས་ཤུལ་བཞག་གི་རྒྱུན་འཛིན་པ།",
          id: 2,
        },
        {
          title: "民间工艺师",
          eng_title: "Folk Craftsman",
          za_title: "དམངས་ཁྲོད་བཟོ་རྩལ་མཁས་པ་",
          id: 3,
        },
      ],
      language: this.$store.state.language,
      list: [],
      levels: [],
      levelList: [
        {
          id: 0,
          level: "全部",
          eng_level: "All",
          za_level: "ཚང་མ་ནི།",
        },
        {
          id: 1,
          level: "国家级",
          eng_level: "national level",
          za_level: "རྒྱལ་ཁབ།",
        },
        {
          id: 2,
          level: "省级",
          eng_level: "provincial level",
          za_level: "ཞིང་ཆེན།",
        },
        {
          id: 3,
          level: "州级",
          eng_level: "state level",
          za_level: "ཁུལ་རིམ་པ།",
        },
        {
          id: 4,
          level: "市级",
          eng_level: "city level",
          za_level: "གྲོང་ཁྱེར་རིམ་པ་",
        },
      ],
      folkList: [
        {
          id: 0,
          level: "全部",
          eng_level: "All",
          za_level: "ཚང་མ་ནི།",
        },
        {
          id: 1,
          level: "省级",
          eng_level: "Provincial level",
          za_level: "ཞིང་ཆེན་རིམ་པ་",
        },
        {
          id: 2,
          level: "省一级",
          eng_level: "Provincial First level",
          za_level: "ཞིང་ཆེན་རིམ་པ་",
        },
        {
          id: 3,
          level: "省二级",
          eng_level: "Provincial Second level",
          za_level: "ཞིང་ཆེན་རིམ་པ་གཉིས་པ།",
        },
        {
          id: 4,
          level: "省三级",
          eng_level: "Provincial Third level",
          za_level: "ཞིང་ཆེན་རིམ་པ་གསུམ་པ་",
        },
        {
          id: 5,
          level: "州级",
          eng_level: "state level",
          za_level: "ཁུལ་རིམ་པ།",
        },
        {
          id: 6,
          level: "市级",
          eng_level: "city level",
          za_level: "གྲོང་ཁྱེར་རིམ་པ་",
        },
      ],
      url: process.env.VUE_APP_WEB_URL,
      total: null,
      queryInfo: {
        inheritorLevel: "",
        artistsLevel: "",
        technologistLevel: "",
        current: 1,
        pageSize: 10,
        name: "",
      },
      loading: false,
      isLoading: false,

      Info: {
        current: 1,
        pageSize: 10,
      },

      isMobile: false,
    };
  },
  computed: {
    changeLanguage() {
      return this.$store.state.language;
    },
  },
  watch: {
    changeLanguage: function (val) {
      this.language = val;
    },
  },
  mounted() {
    new this.$wow.WOW().init();
  },
  created() {
    this.getPCorMobile();
    this.levels = this.levelList;
  },
  methods: {
    // 选择非遗或者工艺
    goPainting(id, index) {
      // document.documentElement.scrollTop = 0
      this.isActive = id;
      this.isActives = 0;
      if (id == 0) {
        this.levels = this.levelList;
        this.queryInfo.inheritorLevel = "";
        this.queryInfo.artistsLevel = "";
        this.queryInfo.technologistLevel = "";
      } else if (id == 1) {
        this.levels = this.levelList;
        this.queryInfo.inheritorLevel = "";
        this.queryInfo.artistsLevel = 0;
        this.queryInfo.technologistLevel = "";
      } else if (id == 2) {
        this.levels = this.levelList;
        this.queryInfo.inheritorLevel = 0;
        this.queryInfo.artistsLevel = "";
        this.queryInfo.technologistLevel = "";
      } else if (id == 3) {
        this.levels = this.folkList;
        this.queryInfo.inheritorLevel = "";
        this.queryInfo.artistsLevel = "";
        this.queryInfo.technologistLevel = 0;
      }
      this.list = [];
      this.total = null;
      this.getNewsList();
    },
    goPaintings(id, index) {
      // document.documentElement.scrollTop = 0
      if (this.isActive == 0) {
        let message = "";
        if (this.language == "eng") {
          message = "Please select the professional title of the inheritor";
        } else if (this.language == "en") {
          message = "རྒྱུན་འཛིན་པའི་གོ་མིང་འདེམས་རོགས་།";
        } else {
          message = "请选择传承人职称";
        }
        this.$message({
          showClose: true,
          message: message,
          type: "warning",
        });
      } else {
        this.isActives = id;
        if (this.isActive == 1) {
          if (this.isActives == 0) {
            this.queryInfo.artistsLevel = 0;
          } else {
            this.queryInfo.artistsLevel = this.isActives;
          }
          this.queryInfo.inheritorLevel = "";
          this.queryInfo.technologistLevel = "";
          this.list = [];
          this.total = null;
          this.getNewsList();
        } else if (this.isActive == 2) {
          if (this.isActives == 0) {
            this.queryInfo.inheritorLevel = 0;
          } else {
            this.queryInfo.inheritorLevel = this.isActives;
          }
          this.queryInfo.artistsLevel = "";
          this.queryInfo.technologistLevel = "";
          this.list = [];
          this.total = null;
          this.getNewsList();
        } else {
          if (this.isActives == 0) {
            this.queryInfo.technologistLevel = 0;
          } else {
            this.queryInfo.technologistLevel = this.isActives;
          }
          this.queryInfo.artistsLevel = "";
          this.queryInfo.inheritorLevel = "";
          this.list = [];
          this.total = null;
          this.getNewsList();
        }
      }
    },
    handSearchOther() {
      if(this.isMobile) {
        // 手机
        this.Info.current = 1
        this.getMobileNewsList()
      } else {
        // PC
        this.queryInfo.current = 1
        this.list = []
        this.total = null
        this.getNewsList()
      }
    },
    async getNewsList() {
      this.loading = true;
      const res = await inherit(this.queryInfo);
      if (res.code == 1) {
        this.loading = false;
        this.isLoading = false;
        this.list = this.list.concat(res.data.records);
        this.total = res.data.total;
      }
    },
    getPCorMobile() {
      if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        this.getMobileNewsList();
        this.isMobile = true;
        window.addEventListener("scroll", this.Scrollbottom, true);
      } else {
        this.getNewsList();
        this.isMobile = false;
        window.addEventListener("scroll", this.PCscrollBottom, true);
      }
    },
    PCscrollBottom() {
      // 变量scrollTop为当前页面的滚动条纵坐标位置
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 变量 windowHeight 是可视区的高度
      let windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      // 变量 scrollHeight 是滚动条的总高度
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      // 到底的条件
      if (scrollTop + windowHeight == scrollHeight) {
        //到底后要去触发的事件
        if (this.isLoading) {
          if (this.queryInfo.current * 10 >= this.total) {
            this.loading = false;
            return this.$message("数据加载完毕");
          }
          this.loading = true;
          this.queryInfo.current++;
          this.getNewsList();
        }
      } else {
        this.isLoading = true;
      }
    },
    async getMobileNewsList() {
      this.loading = true;
      const res = await inherit({
        current: this.Info.current,
        pageSize: this.Info.pageSize,
        inheritorLevel: this.queryInfo.inheritorLevel,
        artistsLevel: this.queryInfo.artistsLevel,
        technologistLevel: this.queryInfo.technologistLevel,
        name: this.queryInfo.chineseName,
      });
      if (res.code == 1) {
        this.loading = false;
        this.isLoading = false;
        this.list = this.list.concat(res.data.records);
        this.total = res.data.total;
      }
    },
    Scrollbottom: throttle(function (event) {
      // 变量scrollTop为当前页面的滚动条纵坐标位置
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // 变量 windowHeight 是可视区的高度
      let windowHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      // 变量 scrollHeight 是滚动条的总高度
      let scrollHeight =
        document.documentElement.scrollHeight || document.body.scrollHeight;
      // 到底的条件
      if (scrollTop + windowHeight + 100 >= scrollHeight) {
        if (this.isLoading) {
          if (this.Info.current * 10 >= this.total && this.total > 0) {
            this.loading = false;
            return this.$message("数据加载完毕");
          }
          this.loading = true;
          this.Info.current++;
          this.getMobileNewsList();
        }
      } else {
        this.isLoading = true;
      }
    }, 2000),
    goDetail(item) {
      if (item.link) {
        window.open(item.link);
      } else {
        this.$router.push({ path: "/inheritDetail", query: { id: item.id } });
      }
    },
    handleRouter(num) {
      this.$store.commit("changeNum", num);
      this.$router.push("/index");
    },
    handleFocus(event) {
      // 获取input的DOM元素
      const input = this.$refs.searchInput.$el.querySelector('input');
      // 添加自定义的边框颜色
      input.style.border = '1px solid #9a131b';
    },
    handleBlur(event) {
      // 当input失去焦点时，恢复边框颜色
      const input = this.$refs.searchInput.$el.querySelector('input');
      input.style.border = '1px solid #DCDFE6';
    }
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.ScrollBottom, true);
    window.removeEventListener("scroll", this.PCscrollBottom, true);
  },
};
</script>
<style lang="scss" scoped>
.inherit {
  background: url("../../assets/newImage/index/could_right.png") no-repeat right
    bottom;
  background-position: 100% 100%;
  position: relative;
  background-size: 7%;
  .exhibitionTop {
    position: relative;
    border-bottom: 1px solid #f4f5f6;
    .section {
      padding: 50px 0;
      font-size: 18px;
      position: relative;
      .section_left {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        z-index: 88;
        .color {
          color: #ed201a;
        }
        span {
          cursor: pointer;
        }
      }
      .search_input {
        position: absolute;
        top: 50%;
        right: 20px;
        transform: translateY(-50%);
        z-index: 88;
        display: flex;
        .el-input {
          width: 240px;
          /deep/.el-input__inner {
            width: 240px;
            padding: 0 32px 0 15px!important;
          }
        }
        .searchButton {
          position: absolute;
          top: 50%;
          right: 5px;
          transform: translateY(-50%);
          color: #fff;
          border: none;
          border-radius: 5px;
          cursor: pointer;
          img {
            height: 26px;
          }
        }
      }
    }
    .cloudLeft {
      position: absolute;
      top: 50px;
      left: 0;
      z-index: 1;
      width: 125px;
      height: 95px;
    }
  }
  .inheritContent {
    margin: 50px 0 60px 0;
    .level,
    .people {
      display: flex;
      width: 1200px;
      margin: 0 auto;
      .person {
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        width: 180px;
        margin-right: 4px;
        font-size: 20px;
        height: 60px;
        position: relative;
        font-family: "fangzang";
        color: #110b0b;
      }
      .isActive {
        background-color: #304462;
        color: #fff;
      }
    }
    .level {
      margin-top: 20px;
    }
    .section {
      margin-top: 50px;
      .item {
        margin-bottom: 40px;
        display: flex;
        align-items: center;
        cursor: pointer;
        .left {
          img {
            width: 180px;
            height: 240px;
          }
        }
        .right {
          margin-left: 50px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .title,
          .content {
            overflow: hidden !important;
            overflow-wrap: break-word !important;
            text-overflow: ellipsis !important;
            -webkit-box-orient: vertical !important;
            display: -webkit-box !important;
          }
          .title {
            font-size: 20px;
            font-family: "fangzang";
            color: #110b0b;
          }
          .content {
            text-align: justify;
            font-size: 14px;
            line-height: 25px;
            margin-top: 20px;
            -webkit-line-clamp: 2 !important;
            cursor: pointer;
            color: #595959;
          }
          .eng_title {
            font-family: "Times New Roman", Times, serif;
          }
          .master {
            margin-top: 10px;
            color: #110b0b;
            display: flex;
            font-size: 16px;
            .inheritorNameList {
              display: flex;
              .inheritorNameItem {
                > div {
                  margin-right: 10px;
                }
              }
            }
            .artistsLevelNameList {
              display: flex;
              .artistsLevelNameItem {
                > div {
                  margin-right: 10px;
                }
              }
            }
            .folkLevelNameList {
              display: flex;
            }
          }
          .englishMaster {
            display: flex;
            flex-direction: column;
            .inheritorNameList {
              display: flex;
              .inheritorNameItem {
                > div {
                  margin-right: 10px;
                }
              }
            }
            .artistsLevelNameList {
              display: flex;
              .artistsLevelNameItem {
                > div {
                  margin-right: 10px;
                }
              }
            }
            .folkLevelNameList {
              display: flex;
            }
          }
        }
      }
    }
    .noneContent {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 10px 0;
      font-size: 24px;
      font-weight: 600;
      letter-spacing: 4px;
    }
    .loading {
      margin: 30px 0 20px 0;
      .el-loading-mask {
        .el-loading-spinner {
          .el-icon-loading {
            color: #ef3731;
          }
          .el-loading-text {
            color: #ef3731;
          }
        }
      }
    }
  }
}
@media (max-width: 768px) {
  .inherit {
    background: url("../../assets/newImage/index/could_right.png") no-repeat
      right bottom;
    background-size: 1rem;
    position: relative;
    padding-bottom: 0.3rem;
    .exhibitionTop {
      position: relative;
      .section {
        background: url("../../assets/newImage/index/could_left.png") no-repeat
          top left;
        background-position: 0 50%;
        background-size: 15%;
        padding: 0.6rem 0.2rem;
        font-size: 0.3rem;
        .section_left {
          left: 0.2rem;
        }
        .search_input {
          position: absolute;
          top: 50%;
          right: .2rem!important;
          transform: translateY(-50%);
          z-index: 88;
          display: flex;
          margin-bottom: 20px;
          width: 4rem;
          .el-input {
            width: 100%;
            height: .7rem;
            /deep/ .el-input__inner {
              width:100%!important;
              font-size: .25rem;
              height: .7rem;
              padding: 0 45px 0 15px!important;
            }
          }
          /deep/.searchButton {
            position: absolute;
            top: 50%;
            right: 0.1rem;
            transform: translateY(-50%);
            color: #fff;
            border: none;
            border-radius: 5px;
            cursor: pointer;
            img {
              height: .5rem;
            }
          }
        }
      }
      .cloudRight {
        position: absolute;
        top: 6%;
        right: 0;
        width: 1.25rem;
      }
    }
    .inheritContent {
      margin: 0.5rem 0 0 0;
      .level,
      .people {
        margin-left: 0.1rem;
        display: flex;
        width: 100%;
        justify-content: flex-start;
        .person {
          cursor: pointer;
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
          width: 1.6rem;
          font-size: 16px;
          height: 0.6rem;
          position: relative;
          font-family: "fangzang";
        }
        .englishPerson {
          font-size: 0.25rem;
          height: 1.2rem;
        }
        .isActive {
          background-color: #304462;
          color: #fff;
        }
      }
      .level {
        margin-top: 20px;
      }
      .section {
        margin-top: 0.3rem;
        .item {
          width: 100%;
          margin-bottom: 0.5rem;
          .left {
            width: 26%;
            img {
              height: 2.4rem;
              width: 100%;
            }
          }
          .right {
            margin-left: 0.001rem;
            width: 74%;
            padding: 0 0.1rem;
            .title,
            .content {
              overflow: hidden !important;
              overflow-wrap: break-word !important;
              text-overflow: ellipsis !important;
              display: -webkit-box !important;
              -webkit-line-clamp: 2 !important;
              -webkit-box-orient: vertical !important;
            }
            .master {
              font-size: 0.24rem;
              margin: 0.1rem 0;
              display: flex;
              flex-direction: column;
              font-weight: 500;
              .inheritorNameList {
                width: 100%;
                display: flex;
                flex-direction: column;
                .inheritorNameItem {
                  > div {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                }
              }
              .artistsLevelNameList {
                display: flex;
                flex-direction: column;
                .artistsLevelNameItem {
                  > div {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                }
              }
              .folkLevelNameList {
                > div {
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
              }
            }
            .title {
              font-size: 0.24rem !important;
              margin-bottom: 0.1rem;
            }
            .content {
              line-height: 0.4rem;
              margin-top: 0;
              font-size: 0.25rem !important;
            }
          }
        }
        .item:last-child {
          margin-bottom: 0;
        }
      }
      .loading {
        margin: 0.5rem 0 0 0;
        padding-bottom: 0.1rem;
      }
      .noneContent {
        margin-top: 0.3rem;
        font-size: 0.3rem;
      }
    }
    .mobilecloudLeft {
      position: absolute;
      bottom: -3.5%;
      right: 0;
      width: 1.25rem;
    }
  }
}
</style>
